<template>
  <div style="padding:20px">
    <p class="station-online-title">员工职场信息维护</p>
    <van-form @submit="onSubmit">
      <van-field label="姓名" name="用户名" v-model="name" readonly></van-field>
      <van-field readonly label="工号" name="工号" v-model="form.employeeCode"></van-field>
      <van-field label="部门" name="部门" readonly v-model="orgNameLink"></van-field>
      <van-field readonly label="请选择省市" v-model="city" placeholder="点击选择省市" @click="showPicker = 'city'" />
      <van-popup position="bottom" :close-on-click-overlay="false" :value="showPicker === 'city'">
        <van-picker show-toolbar @confirm="ConfirmCityHandler" :columns="cityList" @cancel="showPicker = ''" />
      </van-popup>
      <van-field
        readonly
        :value="workPlace"
        label="请选择职场"
        placeholder="点击选择职场"
        @click="showPicker = 'workplace'"
      />
      <van-popup position="bottom" :close-on-click-overlay="false" :value="showPicker === 'workplace'">
        <van-picker
          value-key="name"
          show-toolbar
          @confirm="onfirmWorkplaceHandler"
          :columns="workplaceList"
          @cancel="showPicker = ''"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        :value="form.seatCode"
        label="请选择工位"
        placeholder="点击选择工位"
        @click="showPicker = 'seatCode'"
      />
      <van-popup position="bottom" :close-on-click-overlay="false" :value="showPicker === 'seatCode'">
        <div class="station-toolbar">
          <span style="color:#969799" @click="showPicker = ''">取消</span>
          <span class="confirm-btn" @click="confirmHandler">确认</span>
        </div>
        <van-search
          placeholder="输入关键字搜索工位"
          v-model="searchValue"
          @input="searchHandler"
          style="margin-top:10px"
        />
        <van-empty show-toolbar v-show="stationList.length <= 0"> </van-empty>
        <van-picker
          ref="seatPicker"
          v-show="stationList.length > 0"
          value-key="code"
          v-model="seatPickerValue"
          :columns="stationList"
        >
        </van-picker>
      </van-popup>
      <div style="margin: 25px;">
        <van-button round block type="info" native-type="submit">确认提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import { getUserDetail, getCityCodeList, getSeatList, bindSeat, getCityList, checkSeat } from '@api/station';
import { Field, Form, Popup, Picker, Button, Notify, Empty, Search, Dialog } from 'vant';
import * as dd from 'dingtalk-jsapi';

Vue.use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Button)
  .use(Notify)
  .use(Empty)
  .use(Search)
  .use(Dialog);

export default {
  data() {
    return {
      form: {
        workPlaceId: '',
        seatCode: '',
        employeeCode: '',
        orgCode: '',
      },
      selectedSeatId: 0,
      name: '',
      orgNameLink: '',
      orgCodeLink: '',
      city: '',
      cityList: [],
      workplaceList: [],
      stationList: [],
      showPicker: '',
      workPlace: '',
      employeeDetail: {},
      searchValue: '',
      seatPickerValue: '',
      timer: '',
    };
  },
  mounted() {
    this.getStaffDetail();
    this.getCityListHandler();
  },
  methods: {
    async getStaffDetail() {
      const res = await getUserDetail();
      if (res) {
        this.name = res.name;
        this.form.employeeCode = res.empNo;
        this.orgNameLink = res.orgNameLink;
        this.form.orgCode = res.orgCode;
        this.orgCodeLink = res.orgCodeLink;
        this.city = res.cityName;
        this.cityNumber = res.cityNumber;
        this.workPlace = res.workPlaceName;
        this.form.workPlaceId = res.workPlaceId;
        this.form.seatCode = res.seatCode;
        if (res.cityNumber) {
          const resp = await getCityCodeList({ cityNumber: res.cityNumber });
          this.workplaceList = resp;
        }
        if (res.workPlaceId) {
          const data = await getSeatList({
            orgCodeLink: res.orgCodeLink,
            workPlaceId: res.workPlaceId,
          });
          this.stationList = data;
        }
      }
    },
    async onSubmit() {
      // 校验工位是否已绑定
      const _this = this;
      const check = await checkSeat({
        seatId: _this.selectedSeatId,
      });
      // console.log(check);
      if (check && check.employeeName) {
        Dialog.confirm({
          message: `当前工位已被${check.employeeName}绑定，是否确认工位信息无误`,
        }).then(() => {
          _this.handleBindSeat();
        }).catch(() => {

        });
      } else {
        _this.handleBindSeat();
      }
    },
    // 绑定工位
    async handleBindSeat() {
      const res = await bindSeat({ ...this.form });
      if (!res) {
        Dialog.confirm({
          message: `工位绑定成功！</br>您的工位是：${this.workPlace} ${this.form.seatCode}。`,
          showCancelButton: false,
        }).then(() => {
          dd.biz.navigation.close();
        });
      } else if (res.code === '1') {
        Dialog({
          message: res.message,
        });
      }
    },
    async getCityListHandler() {
      const res = await getCityList();
      for (const key in res) {
        this.cityList.push({
          text: res[key],
          value: key,
        });
      }
    },
    async ConfirmCityHandler(val) {
      this.showPicker = '';
      this.city = val.text;
      this.workPlace = '';
      this.form.workPlaceId = '';
      this.form.seatCode = '';
      const res = await getCityCodeList({ cityNumber: val.value });
      this.workplaceList = res;
      this.stationList = [];
    },
    async onfirmWorkplaceHandler(val) {
      this.showPicker = '';
      this.form.workPlaceId = val.id;
      this.workPlace = val.name;
      const params = {
        orgCodeLink: this.orgCodeLink,
        workPlaceId: this.form.workPlaceId,
      };
      this.form.seatCode = '';
      const res = await getSeatList(params);
      this.stationList = res;
    },
    searchHandler(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        const params = { orgCodeLink: this.orgCodeLink, workPlaceId: this.form.workPlaceId, seatCode: val };
        const res = await getSeatList(params);
        this.stationList = res;
      }, 300);
    },
    // 选中工位
    confirmHandler() {
      const data = this.$refs.seatPicker.getValues();
      this.showPicker = '';
      this.form.seatCode = data[0].code;
      this.selectedSeatId = data[0].id;
    },
  },
};
</script>

<style lang="scss">
@import '@assets/css/var.scss';
.station-online-title {
  margin-top: 15vh;
  margin-bottom: 80px;
  text-align: center;
}
.station-toolbar {
  font-size: 28px;
  padding: 20px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  .confirm-btn {
    color: $color-blue;
  }
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: $color-blue;
}
</style>
